module.exports = __webpack_public_path__ + "sunsemweb/img/E.01ab61b4.png";